import { ContextMenuAction } from '@/components/ContextMenu/types.ts';
import { PageTab } from '@/components/pages/BasePage/types.ts';
import { MaybeRefOrGetter } from 'vue';

export enum TabIndicatorState {
  DEFAULT = 'primary',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export type ActiveTabType = 'review' | 'completed' | 'open';

export type Tab = {
  title: MaybeRefOrGetter<string | undefined>;
  icon?: string;
  hidden?: boolean;
  disabled?: boolean;
  indicatorState?: MaybeRefOrGetter<TabIndicatorState | undefined>;
  contextMenuActions?: ContextMenuAction[];
  handleSelect?: (key: string, index: number, tab: Tab) => void;
};

export type TabDefinition<T extends Tab | PageTab = PageTab, K extends string = string> = Record<
  K,
  T
>;

export type TabSlots = {
  [k in string]: (props: unknown) => void;
};
